/**
 * Tab Component
 *
 * @file tab.js
 */

import $ from 'jquery';


const timeLine = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const homeTimeline = () => {
    $(document).ready(function() {
      if($(".section-timeline").is(":visible")){
        var $window = $(window);
        var $tlSection = $('.section-timeline');
        var $tlWrapper = $('.theme-timeline');
        var $tlIndicator = $('.timeline-indicator');



        const scrollContainer = document.querySelector(".section-timeline");
        scrollContainer.addEventListener("wheel", (evt) => {
            evt.preventDefault();
            scrollContainer.scrollLeft += evt.deltaY * 0.4;
        });

        $(".section-timeline").on("scroll", function() {
          var scrollLeftPos = $(".section-timeline").scrollLeft();
          console.log(scrollLeftPos);
          $(".timeline-indicator").css("left",scrollLeftPos);
        });

        function timeline_init() {
            $tlWrapper.on('scroll', animate_indicator);

            $('body').on('scroll', animate_indicator);
            $tlSection.on('scroll', animate_indicator);
            $tlSection.on('resize', position_indicator);

            position_indicator();
            animate_indicator();
        }

        function animate_indicator(e) {
            const waveLength = 1000; // wave-dotted.svg viewbox width
            const waveHeight = 120; // wave-dotted.svg viewbox height
            const maxRotation = 25;

            const degreeFactor = 360 / waveLength;

            let scrollOffset;

            scrollOffset = $tlSection.scrollLeft() || window.pageXOffset;
            scrollOffset = -(scrollOffset + parseInt($tlSection.css('paddingLeft').replace(/[^-\d\.]/g, '')));

            let degrees = (scrollOffset * degreeFactor) % 360;
            const radians = degrees * (Math.PI / 180);
            const amplitude = Math.sin(radians);

            const indicatorOffset = amplitude * (waveHeight / 2);
            let indicatorRotation = (1 - Math.abs(amplitude)) * maxRotation;

            degrees = Math.abs(degrees);

            if (degrees < 90 || degrees > 270) {
                indicatorRotation = -(indicatorRotation);
            }

            $tlIndicator.css({
                'transform': `translateY(${indicatorOffset}px) rotate(${indicatorRotation}deg)`,
            });
        }

        function position_indicator(e) {
          // const $firstMarker = $('.timeline-marker:eq(0)');
          // const markerPos = $firstMarker.offset();
          // console.log(markerPos);

          // $tlIndicator.css({
          //     'top': markerPos.top
          // });
        }

        if ($tlWrapper.length) timeline_init();
      }
    });
  };

  const init = () => {
    homeTimeline();
  };

  return {
    init,
  };
})();

export default timeLine;
